import Immutable from 'immutable';

import ClassFactory from 'sharedreact/utils/ClassFactory';

const Content: {
  id: string,
  name: string,
  version: string,
  status: string
} = {
  id: '',
  name: '',
  version: '',
  status: ''
};

class Agent extends Immutable.Record(Content) {
  static fromJS (json: object): Agent {
    return ClassFactory.createFromJson(json, Agent);
  }
}

export default Agent;
